import * as is from 'is';
import { compareData } from '@utils/objectHandler';

export const getUpdatedSourceData = (previousSourceData, updatedSourceData) => {
  const updatedData = compareData(previousSourceData, updatedSourceData);

  /**
   * uri --------> sdp
   * When a source changes from uri to sdp, the uri values need to be set to null
   */
  if (!is.null(previousSourceData.path) && !is.null(previousSourceData.protocol)
    && !is.undefined(updatedSourceData.sdpInput)) {
    updatedData.path = null;
    updatedData.scheme = null;
    updatedData.port = null;
    updatedData.sdpInput = updatedSourceData.sdpInput;
    /**
     * sdp --------> uri
     * When a source changes from sdp to uri, the sdp input needs to be set to null
     */
  } else if (!is.null(previousSourceData.sdpInput)
    && !is.undefined(updatedSourceData.path) && !is.undefined(updatedSourceData.scheme)) {
    updatedData.sdpInput = null;
    updatedData.path = updatedSourceData.path;
    updatedData.scheme = updatedSourceData.scheme.toLowerCase();
    if (updatedSourceData.port) {
      updatedData.port = updatedSourceData.port;
    }
    /**
     * Now that port is optional, we need a way to set it back to null after having a value previously
     */
  } else if (!is.null(previousSourceData.port) && is.undefined(updatedSourceData.port)) {
    updatedData.port = null;
  }

  /**
   * appliance --------> device OR updating device
   * When the device updates or when the source changes from an appliance to a device
   */
  if (updatedSourceData.deviceId && !is.empty(updatedSourceData.deviceId)) {
    if (is.null(previousSourceData.device) || previousSourceData.device.id !== updatedSourceData.deviceId) {
      updatedData.deviceId = updatedSourceData.deviceId;
      updatedData.applianceId = null;
    }
    /**
     * device --------> appliance OR updating appliance
     * When the appliance updates or when the source changes from a device to an appliance
     */
  } else if (updatedSourceData.applianceId && !is.empty(updatedSourceData.applianceId)) {
    if (is.null(previousSourceData.appliance) || previousSourceData.appliance.id !== updatedSourceData.applianceId) {
      updatedData.applianceId = updatedSourceData.applianceId;
      updatedData.deviceId = null;
    }
  }

  return updatedData;
};

/**
 * Formats the source object keys to camelCase and updates them to match the UI values
 * @param {*} data the source data
 * @param {*} camera camera the source is connected to, if that is provided
 * @returns
 */
export const formatSourceData = (data, camera) => {
  let returnObj = {
    ...data,
    protocol: data?.scheme,
    sdpInput: data?.sdp_input,
    inputType: !is.empty(data?.sdp_input) && !is.null(data?.sdp_input)
      ? 'SDP'
      : !is.empty(data?.path) && !is.null(data?.path)
        ? 'URI'
        : null,
  };

  if (camera) {
    returnObj.type = 'Camera';
    returnObj.device = camera;
  } else {
    returnObj.type = data?.device?.name
      ? 'Camera'
      : data?.appliance?.name
        ? 'Appliance'
        : null;
  }
  return returnObj;
};